import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API } from '@/App';
import CompanionFull from '@/components/companion/CompanionFull';

/** The participant's own full Companion. Reached from the FULL tab. */
const CompanionPage = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  const load = useCallback(() => {
    axios.get(`${API}/assessments/my/companion`)
      .then((res) => setData(res.data))
      .catch(() => setError(true));
  }, []);

  useEffect(() => { load(); }, [load]);

  if (error) {
    return (
      <div className="text-center py-20 text-white/60" data-testid="companion-page-error">
        Your Companion could not be loaded.
      </div>
    );
  }
  if (!data) {
    return <div className="text-center py-20 text-white/60">Opening your Companion…</div>;
  }

  return (
    <div className="max-w-4xl mx-auto" data-testid="companion-page">
      <CompanionFull data={data} onReload={load} />
    </div>
  );
};

export default CompanionPage;
